/**
 *
 * App.react.js
 *
 * This component is the skeleton around the actual pages, and should only
 * contain code that should be seen on all pages. (e.g. navigation bar)
 *
 * NOTE: while this component should technically be a stateless functional
 * component (SFC), hot reloading does not currently support SFCs. If hot
 * reloading is not a neccessity for you then you can refactor it and remove
 * the linting exception.
 */

import React from 'react';
import { Helmet } from 'react-helmet';
import Footer from '../../components/Footer/footer';
import Header from '../../components/Header/header';
import { isCountrySk } from '../../utils/languageLocalStorage';
import { setCountrySettings, setPreviousLocation } from '../../actions/pageSettingsActions';
import LoadingBar from 'react-redux-loading-bar';
import { connect } from 'react-redux';
import MessagePickerContainer from '../Commons/MessagePickerContainer/MessagePickerContainer';

class App extends React.Component {
    componentDidMount() {
        if (isCountrySk()) {
            this.props.fetchCountrySettings('SK');
        } else {
            this.props.fetchCountrySettings('CZ');
        }
    }

    componentWillReceiveProps(nextProps) {
        const loc = this.props.pathname + this.props.search;
        const nextLoc = nextProps.pathname + nextProps.search;
        if (loc !== nextLoc) {
            this.props.setPreviousLocation(loc);
        }
    }

    render() {
        let cartItems = 0;
        if (this.props.packages && this.props.packages.length > 0) {
            cartItems += this.props.packages.length;
        }
        if (this.props.singleProducts && this.props.singleProducts.length > 0) {
            cartItems += this.props.singleProducts.length;
        }

        const hideExtended =
            this.props.pathname === '/kosik' || this.props.pathname === '/doprava-platba';

        return (
            <div>
                <Helmet
                    titleTemplate=" %s | DárkováKrabička.cz"
                    defaultTitle="DárkováKrabička.cz - Udělejte radost svým blízkým originálním dárkem"
                    script={[
                        {
                            type: 'text/javascript',
                            innerHTML: 'window.yourObject = { it: "works" }'
                        }
                    ]}
                >
                    <title>
                        DárkováKrabička.cz - Udělejte radost svým blízkým originálním dárkem
                    </title>
                    <meta property="og:type" content="website" />
                    <meta
                        name="description"
                        content="Sestavte si dárkové balíčky online z originálních produktů. Krásné osobní věnování a dodání až k vám zajistíme do dvou pracovních dní"
                    />
                    <meta property="og:title" content="Dárková Krabička.cz" />
                    <meta property="og:site_name" content="Dárková krabička" />
                    <meta property="og:type" content="website" />
                    <meta
                        property="og:description"
                        content="Sestavte si dárkové balíčky online z originálních produktů. Krásné osobní věnování a dodání až k vám zajistíme do dvou pracovních dní!"
                    />
                    <meta
                        property="og:image"
                        content="https://darkovakrabicka.imgix.net/lookbook-01.jpg?dpr=2&auto=format,compress&w=1600"
                    />
                    <meta property="og:url" content={window.location.href} />
                    <meta
                        property="twitter:image"
                        content="https://darkovakrabicka.imgix.net/lookbook-01.jpg?dpr=2&auto=format,compress&w=1600"
                    />
                    <meta name="twitter:card" content="summary_large_image" />
                    <meta
                        property="twitter:description"
                        content="Sestavte si dárkové balíčky online z originálních produktů. Krásné osobní věnování a dodání až k vám zajistíme do dvou pracovních dní!"
                    />

                    <link
                        href="https://fonts.googleapis.com/css?family=Open+Sans:400,700,800&display=swap&subset=latin-ext"
                        rel="stylesheet"
                    />
                </Helmet>
                <LoadingBar
                    style={{
                        backgroundColor: '#E96D58',
                        height: '3px',
                        position: 'fixed',
                        zIndex: 9999
                    }}
                />
                <Header cartItems={cartItems} />

                {React.Children.toArray(this.props.children)}

                <Footer hideExtended={hideExtended} />
                <MessagePickerContainer />
            </div>
        );
    }
}

function mapStateToProps(state, ownProps) {
    return {
        pathname: ownProps.location.pathname,
        search: ownProps.location.search,
        packages: state.cart.packages,
        singleProducts: state.cart.singleProducts
    };
}

export default connect(
    mapStateToProps,
    {
        setPreviousLocation,
        fetchCountrySettings: setCountrySettings
    }
)(App);
